import * as React from 'react';
import { ArticleHeading4, UIText2 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';
import { IPromo } from '../../types/newbuilding/promos';
import { PromoItemIcon } from '../PromoItemIcon';

interface IPromoItemProps {
  promo: IPromo;
  onClick(): void;
}

export function PromoItem({ promo, onClick }: IPromoItemProps) {
  const { name, subtitle } = promo;

  return (
    <div className={styles['container']} onClick={onClick} data-testid="PromoItem">
      <div className={styles['icon-wrapper']}>
        <PromoItemIcon promo={promo} />
      </div>
      <div>
        <div className={styles['title']}>
          <ArticleHeading4 as="h4">{name}</ArticleHeading4>
        </div>
        <div className={styles['subtitle']}>
          {subtitle && <UIText2 color="text-secondary-default">{subtitle}</UIText2>}
        </div>
      </div>
    </div>
  );
}
